var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIProvisional(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i_provisional") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Earning-Through-Referral-Copy-2",
    transform: "translate(-266.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i_provisional",
    transform: "translate(266.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF7600",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,3 C9.32608245,3 10.597852,3.5267842 11.5355339,4.46446609 C12.4732158,5.40214799 13,6.67391755 13,8 C13,10.7614237 10.7614237,13 8,13 C5.23857625,13 3,10.7614237 3,8 C3,5.23857625 5.23857625,3 8,3 Z M8,4 C5.790861,4 4,5.790861 4,8 C4,10.209139 5.790861,12 8,12 C9.06086596,12 10.0782816,11.5785726 10.8284271,10.8284271 C11.5785726,10.0782816 12,9.06086596 12,8 C12,5.790861 10.209139,4 8,4 Z M8,5 C8.27614237,5 8.5,5.22385763 8.5,5.5 L8.5,5.5 L8.5,8 C8.49812148,8.13188463 8.44420713,8.25768477 8.35,8.35 L8.35,8.35 L6.85,9.85 C6.72780506,9.99268808 6.5359408,10.054841 6.35329051,10.0109051 C6.17064023,9.96696916 6.02803084,9.82435977 5.98409493,9.64170949 C5.94015903,9.4590592 6.00231192,9.26719494 6.145,9.145 L6.145,9.145 L7.5,7.795 L7.5,5.5 C7.5,5.22385763 7.72385763,5 8,5 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIProvisional);
export default __webpack_public_path__ + "static/media/i_provisional.3005857c1509dba1352557dfb063e499.svg";
export { ForwardRef as ReactComponent };